/**
 * Technical defaults the builder applies based on user-meaningful input.
 * Pure data tables — no logic. Each table is keyed by a user-facing field
 * value and yields the technical fields the builder uses on the seed spec.
 *
 * "Form lean / builder deep" — this is the deep half.
 */

export const HOLE_DEFAULTS = {
  M3: { nominal: 3, throughOversize: 0.2, csAngleDeg: 90, csDepthRatio: 0.5, edgeOffsetMul: 2 },
  M4: { nominal: 4, throughOversize: 0.2, csAngleDeg: 90, csDepthRatio: 0.5, edgeOffsetMul: 2 },
  M5: { nominal: 5, throughOversize: 0.3, csAngleDeg: 90, csDepthRatio: 0.5, edgeOffsetMul: 2 },
  M6: { nominal: 6, throughOversize: 0.3, csAngleDeg: 90, csDepthRatio: 0.5, edgeOffsetMul: 2 },
  M8: { nominal: 8, throughOversize: 0.3, csAngleDeg: 90, csDepthRatio: 0.5, edgeOffsetMul: 2 },
  M10: { nominal: 10, throughOversize: 0.4, csAngleDeg: 90, csDepthRatio: 0.5, edgeOffsetMul: 2 },
} as const;

/** Heat-set insert dimensions: outer boss / hole id / boss height / lead-in. */
export const HEAT_SET_DEFAULTS = {
  M2: { bossOd: 4.5, holeId: 3.2, bossHeight: 6, leadIn: 0.5 },
  'M2.5': { bossOd: 5.5, holeId: 3.6, bossHeight: 7, leadIn: 0.5 },
  M3: { bossOd: 6.5, holeId: 4.0, bossHeight: 8, leadIn: 0.5 },
  M4: { bossOd: 8.0, holeId: 5.6, bossHeight: 10, leadIn: 0.5 },
  M5: { bossOd: 9.5, holeId: 6.4, bossHeight: 12, leadIn: 0.5 },
} as const;

/** Print-tolerance class → hole oversize and shaft undersize in mm. */
export const PRINT_TOLERANCE_FITS = {
  loose: { holeOversize: 0.5, shaftUndersize: 0.4, firstLayerChamfer: 0.5 },
  standard: { holeOversize: 0.4, shaftUndersize: 0.3, firstLayerChamfer: 0.5 },
  tight: { holeOversize: 0.3, shaftUndersize: 0.2, firstLayerChamfer: 0.5 },
} as const;

/** Furniture leg cross-section defaults (square mm). */
export const LEG_CROSS_SECTION = {
  straight: 50,
  tapered: 50,
  turned: 60,
  trestle: 60,
  pedestal: 100,
  splayed: 50,
  cabriole: 70,
  panel: 0, // leg becomes a panel-leg; builder substitutes
  metal: 30, // metal tube section
} as const;

/** Furniture material default-thickness (panels, mm). */
export const PANEL_THICKNESS = {
  plywood: 18,
  hardwood: 25,
  softwood: 25,
  mdf: 18,
} as const;

/** Mating-surface clearance bump per surface finish (mm). */
export const SURFACE_FINISH_CLEARANCE = {
  as_machined: 0,
  powder_coat: 0.1,
  anodized: 0.05,
  plated: 0.05,
  painted: 0.1,
  ground: 0,
  polished: 0,
} as const;
